exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lada-60-js": () => import("./../../../src/pages/lada-60.js" /* webpackChunkName: "component---src-pages-lada-60-js" */),
  "component---src-pages-svatba-js": () => import("./../../../src/pages/svatba.js" /* webpackChunkName: "component---src-pages-svatba-js" */)
}

